import { render, staticRenderFns } from "./EnacCustomAtplResourceLinksForm.vue?vue&type=template&id=20d5272b"
import script from "./EnacCustomAtplResourceLinksForm.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplResourceLinksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports